import auth from '@/router/auth'
import CategoryCourseIndex from '@/components/category-tests/Index'
import CategoryCourseCreate from '@/components/category-tests/Create'
import CategoryCourseUpdate from '@/components/category-tests/Update'
import CategoryCourseShow from '@/components/category-tests/Show'
import CategoryCourseMatrix from '@/components/category-tests/Matrix.vue'

export default [
  {
    path: '/category-tests',
    name: 'category-tests-index',
    component: CategoryCourseIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/category-tests/matrix',
    name: 'category-tests-matrix',
    component: CategoryCourseMatrix,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/category-tests/create',
    name: 'category-tests-create',
    component: CategoryCourseCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/category-tests/update/:id',
    name: 'category-tests-update',
    component: CategoryCourseUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/category-tests/show/:id',
    name: 'category-tests-show',
    component: CategoryCourseShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/category-tests/router.js